<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <template v-for="(item, index) in levelList">
        <template
          v-if="item.meta.breadcrumb && item.meta.breadcrumb.length > 0"
        >
          <el-breadcrumb-item
            v-for="(meta, key) in item.meta.breadcrumb"
            :key="key"
          >
            <el-dropdown v-if="index == 1 && key == 0" @command="handleCommand">
              <span class="el-dropdown-link">
                <span>{{ meta.title }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(column, key) in homeColumns"
                  :key="key"
                  :command="column"
                  >{{ column.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <span
              v-else-if="key == item.meta.breadcrumb.length - 1"
              class="no-redirect"
              >{{ meta.title }}</span
            >
            <router-link v-else :to="meta.path">{{ meta.title }}</router-link>
          </el-breadcrumb-item>
        </template>
        <template v-else>
          <el-breadcrumb-item :key="item.path">
            <el-dropdown v-if="index == 1 && key == 0" @command="handleCommand">
              <span class="el-dropdown-link">
                <span>{{ meta.title }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(column, key) in homeColumns"
                  :key="key"
                  :command="column"
                  >{{ column.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <span
              v-else-if="
                item.redirect === 'noredirect' || index === levelList.length - 1
              "
              class="no-redirect"
              >{{ item.meta.title }}</span
            >
            <router-link v-else :to="item.redirect || item.path">{{
              item.meta.title
            }}</router-link>
          </el-breadcrumb-item>
        </template>
      </template>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  created() {
    this.getBreadcrumb()
    this.$root.eventHub &&
      this.$root.eventHub.$on('updateRoute', () => {
        this.getBreadcrumb()
      })
  },
  data() {
    return {
      levelList: []
    }
  },
  computed: {
    ...mapGetters(['homeColumns'])
  },
  watch: {
    $route: {
      handler() {
        this.getBreadcrumb()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getBreadcrumb() {
      this.levelList = []
      let matched = this.$route.matched.filter((item) => item.name)
      const first = matched[0]
      if (first && first.name !== 'dashboard') {
        matched = [{ path: '/', meta: { title: '首页' }}].concat(matched)
      }
      this.levelList = matched
    },
    handleCommand(item) {
      if (item.url) {
        window.open(item.url, '_blank')
      } else {
        this.$router.push(`/menu/${item.id}`)
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 20px;
  margin-left: 10px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
  .el-dropdown {
    font-weight: bold;
    color: #303133;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue